module.exports = __webpack_public_path__ + "ab8dbba896200c71f76ec099eff8a57e.png";